import React, { Suspense } from "react";

const FuelTableComponent = React.lazy(() => import("./FuelTableComponent"));
const FuelAuditTabComponentLazy = React.lazy(() => import("./FuelAuditTabComponent"));

const FuelManagementComponentLoadable = () => (
    <Suspense fallback={null}>
        <FuelTableComponent />
    </Suspense>
);

const FuelAuditComponentLoadable = () => (
    <Suspense fallback={null}>
        <FuelAuditTabComponentLazy />
    </Suspense>
);

export { FuelManagementComponentLoadable, FuelAuditComponentLoadable };
